import { useColor } from "@commonlibs";
import Logo from "ui/common/components/display/Logo/Logo";
import { LoadingPageWrapper } from "./LoadingPage.styles";
import WidthLimiterLayout from "ui/common/components/layout/WidthLimiterLayout/WidthLimiterLayout";
import { useEffect, useState } from "react";
import { authSessionService } from "features/auth/services/authSessionService";

const LoadingPage = (): JSX.Element => {
    const [canShow, setCanShow] = useState(false);
    const bgColor = useColor("primary");

    useEffect(() => {
        const checkToken = async () => {
            const token = await authSessionService.getAccessToken();
            if (token) setCanShow(true);
        };
        checkToken();
    }, []);

    return (
        <WidthLimiterLayout>
            <LoadingPageWrapper color={bgColor}>{canShow && <Logo color="white" size="lg" />}</LoadingPageWrapper>
        </WidthLimiterLayout>
    );
};

export default LoadingPage;
